module.exports = "<p-calendar [(ngModel)]=\"date\"\n            [locale]=\"fi\"\n            dateFormat=\"dd.mm.yy\"\n            [inline]=\"inline\"\n            inputStyleClass=\"short-input\"\n            [showIcon]=\"true\"\n            [styleClass]=\"styleClass\"\n></p-calendar>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/datepicker/datepicker.component.html
// module id = 469
// module chunks = 2